import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IAppState } from '../../state/app.state';
import { IHoldingsState } from '../../state/holdings.state';

export const getHoldingsState = createFeatureSelector<IAppState, IHoldingsState>('holdings');

export const selectAssetPerformance = createSelector(
    getHoldingsState,
    (state: IHoldingsState) => {
        return state.selectedAssetPerformanceCollection[state.selectedAssetId];
    }
);

export const selectHoldingsDataState = createSelector(
    getHoldingsState,
    (state: IHoldingsState) => {
        return {
            selectedEntities: state.selectedEntities,
            selectedPortfolios: state.selectedPortfolios,
            loading: state.loading,
            error: state.error,
            holdingsExposuresData: state.holdingsExposuresData,
            holdingsValuationData: state.holdingsValuationData,
            selectedDate: state.selectedDate
        };
    }
);
export const selectHoldingsDataLoading = createSelector(
    getHoldingsState,
    (state: IHoldingsState) => {
        return state.loading;
    }
);
export const selectHoldingsDataError = createSelector(
    getHoldingsState,
    (state: IHoldingsState) => {
        return {
            error: state.error,
            errorMessage: state.errorMessage
        };
    }
);

export const selectAssetRevenue = createSelector(
    getHoldingsState,
    (state: IHoldingsState) => state.selectedAssetRevenue
);

export const selectHoldingsValuationData = createSelector(
    getHoldingsState,
    (state: IHoldingsState) => state.holdingsValuationData
);

export const selectHoldingsValuationDataObject = createSelector(
    getHoldingsState,
    (state: IHoldingsState): {
        holdingsVauationsData: any[],
        isValuationsDataLoaded: boolean
    } => {
        return {
            holdingsVauationsData: state.holdingsValuationData,
            isValuationsDataLoaded: state.isValuationsDataLoaded
        };
    }
);

export const selectHoldingsExposuresData = createSelector(
    getHoldingsState,
    (state: IHoldingsState) => state.holdingsExposuresData
);

export const selectAvailableBalance = createSelector(
    getHoldingsState,
    (state: IHoldingsState) => state.availableBalance
);


